import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { getRootStore } from "@/stores/RootStore";
import { observer } from "mobx-react-lite";
import { canEditDictionaries } from "@/utils/permissions";
import { canDeleteFromDictionaries } from "@/utils/permissions";
import { message, Modal, Skeleton, Card, Button, Flex } from "antd";
import styles from "@/styles/VehicleManufacturerPage.module.less";
import { ArrowLeftOutlined, DeleteOutlined } from "@ant-design/icons";
import VehicleManufacturerForm from "@/components/VehicleManufacturerForm";
export const VehicleManufacturerPage = observer(() => {
    const navigate = useNavigate();
    const { vehicleManufacturerId } = useParams();
    const { singleVehicleManufacturerStore: store, authStore: { userRole }, } = getRootStore();
    const { vehicleManufacturer, loading } = store;
    const canEdit = canEditDictionaries(userRole);
    const canDelete = canDeleteFromDictionaries(userRole);
    useEffect(() => {
        store.init(vehicleManufacturerId);
        return () => {
            store.clearVehicleManufacturerData();
        };
    }, [vehicleManufacturerId]);
    const handleBack = () => {
        navigate("/vehicle-manufacturers");
    };
    const handleSave = async (values) => {
        const isNewVehicleManufacturer = !vehicleManufacturer;
        store.saveVehicleManufacturer(values).then((savedVehicleManufacturer) => {
            if (savedVehicleManufacturer) {
                if (isNewVehicleManufacturer) {
                    message.success("Производитель автомобилей успешно создан");
                    navigate(`/vehicle-manufacturers/${savedVehicleManufacturer.id}`);
                }
                else {
                    message.success("Производитель автомобилей успешно обновлен");
                }
            }
        });
    };
    const handleDeleteVehicleManufacturer = () => {
        if (!vehicleManufacturer)
            return;
        Modal.confirm({
            title: "Удаление производителя автомобилей",
            content: "Вы уверены, что хотите удалить этого производителя автомобилей?",
            okText: "Удалить",
            okType: "danger",
            cancelText: "Отмена",
            onOk: async () => {
                await store.deleteVehicleManufacturer(vehicleManufacturer.id);
                message.success("Производитель автомобилей успешно удален");
                handleBack();
            },
        });
    };
    if (loading) {
        return (_jsx("div", { className: styles.container, children: _jsx(Card, { children: _jsx(Skeleton, { active: true, paragraph: { rows: 8 } }) }) }));
    }
    return (_jsxs(Flex, { vertical: true, gap: "large", className: styles.container, children: [_jsx("div", { className: styles.backButtonContainer, children: _jsx(Button, { icon: _jsx(ArrowLeftOutlined, {}), onClick: handleBack, type: "text", className: styles.backButton, children: "\u041D\u0430\u0437\u0430\u0434 \u043A \u0441\u043F\u0438\u0441\u043A\u0443" }) }), _jsx(VehicleManufacturerForm, { vehicleManufacturer: vehicleManufacturer, loading: loading, onSubmit: handleSave, onCancel: handleBack, disabled: !canEdit, extraButtons: canDelete &&
                    vehicleManufacturer && (_jsx(Button, { danger: true, icon: _jsx(DeleteOutlined, {}), onClick: handleDeleteVehicleManufacturer, children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044F \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439" })) })] }));
});
export default VehicleManufacturerPage;
